import { render, staticRenderFns } from "./DamageRequest.vue?vue&type=template&id=6f66d58d&"
import script from "./DamageRequest.vue?vue&type=script&lang=js&"
export * from "./DamageRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports